import { render, staticRenderFns } from "./EntrepreneurParallaxSmall.vue?vue&type=template&id=3b815ab8&"
import script from "./EntrepreneurParallaxSmall.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurParallaxSmall.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurParallaxSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports